import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Box, Button, Flex, Heading } from '@chakra-ui/react'

import { Input } from '@/components/Form'

import SLAQuestionaire from '../SLAQuestionaire'

const SLAForm = ({ SLA, onSubmitAction }) => {
  const methods = useForm({ defaultValues: SLA })

  useEffect(() => {
    if (SLA) {
      methods.reset(SLA)
    }
  }, [SLA, methods])

  const onSubmit = async (data) => {
    onSubmitAction(data)
  }

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> SLA </Heading>
          </Flex>
          <Box p={5}>
            <Flex direction={'column'}>
              <Input name="templateName" label="Template Name" placeholder="Enter value" isRow />
              <SLAQuestionaire name={'questionnaire'} active canEdit />
            </Flex>
            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default SLAForm
